module.exports = __webpack_public_path__ + "img/agrocorp-logo.eff62b4b.png";